import React from "react";
import { useCountdown } from "../hooks/useCountdown";
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  return <div className="mt-6 text-center" role="timer" aria-live="off" data-id="element-94" data-mp="3q15cw8rojys0">
      <p className="text-sm font-bold uppercase tracking-wider text-red-700" data-id="element-95" data-mp="3pzaub13vsir3">Promotional price ends in</p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-96" data-mp="3h0z7la64y53x">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-97" data-mp="323q11989gurm" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-98" data-mp="324rka0zfknkf">
              <span className="flex h-16 w-[4.5rem] items-center justify-center rounded-xl bg-navy-900 font-mono text-3xl font-extrabold tabular-nums text-white md:h-20 md:w-24 md:text-4xl" data-id="element-99" data-mp="372t26il4egub">
                {u.value}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wider text-navy-900/60" data-id="element-100" data-mp="15adcm3cfb2qs">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-4 text-2xl font-extrabold text-navy-900 md:pt-5 md:text-3xl" aria-hidden data-id="element-101" data-mp="t2lhl1rit5y1">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}